import React from "react"
import MerchantDashboard from "./MerchantDashboard"

const CustomDashboard: React.FC = () => {
  return <MerchantDashboard platform="custom" />
}

export default CustomDashboard
